import ErrorMessage from '@shared/components/ErrorMessage';
import React from 'react';

interface AddCompanyFormProps {
  newCompany: { companyName: string; stockTicker: string };
  setNewCompany: React.Dispatch<React.SetStateAction<{ companyName: string; stockTicker: string }>>;
  errors: Record<string, string>;
}

const AddCompanyForm: React.FC<AddCompanyFormProps> = ({ newCompany, setNewCompany, errors }) => {
  return (
    <section className="review-section">
      <header className="review-section__heading">
        <h2 className="review-section__title">About the company</h2>
        <p className="review-section__hint">We don't have this account on file yet — give us the basics.</p>
      </header>

      <div className="review-question">
        <h3 className="review-question__prompt">What is the name of the company you are reviewing?</h3>
        <div className="review-question__answer">
          <input
            type="text"
            className="review-input"
            data-testid="new-company-name-input"
            onChange={(e) =>
              setNewCompany({
                ...newCompany,
                companyName: e.target.value,
              })
            }
            value={newCompany.companyName}
            required
          />
          {errors.economicBuyerName && <ErrorMessage error={errors.economicBuyerName} />}
        </div>
      </div>

      <div className="review-question">
        <h3 className="review-question__prompt">What is the stock ticker of the company you are reviewing?</h3>
        <div className="review-question__answer">
          <input
            type="text"
            className="review-input"
            data-testid="new-company-stock-ticker-input"
            onChange={(e) =>
              setNewCompany({
                ...newCompany,
                stockTicker: e.target.value,
              })
            }
            value={newCompany.stockTicker}
          />
        </div>
      </div>
    </section>
  );
};

export default AddCompanyForm;
